import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ToneFinder from './components/ToneFinder';
import FamousRigs from './components/FamousRigs';
import About from './components/About';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-dark-bg">
        <Navbar />
        <main>
          <Hero />
          <ToneFinder />
          <FamousRigs />
          <About />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
